<form [formGroup]="personForm" class="objects-form pb-3 px-3" style="height:70vh; overflow-y: auto;"><!--(ngSubmit)="submit()"-->
    <div>
        <mat-form-field class="w-50 pr-1">
            <mat-label>{{'FORM.personForm.vorname' | translate}}</mat-label>
            <input formControlName="vorname" matInput type="text">
        </mat-form-field>
        <mat-form-field class="w-50 pl-1">
            <mat-label>{{'FORM.personForm.nachname' | translate}}</mat-label>
            <input formControlName="nachname" matInput type="text">
        </mat-form-field>
    </div>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.personForm.anzeigeName' | translate}}</mat-label>
        <input formControlName="anzeigeName" matInput type="text" required>
    </mat-form-field>

    <!-- Geschlecht -->
    <div class="row justify-content-between">
        <div class="col"> {{'FORM.personForm.geschlecht' | translate}} </div>
        <div class="col">
            <mat-radio-group formControlName="geschlecht" aria-label="Select an option">
                <mat-radio-button value="M">{{'FORM.personForm.genderMale' | translate}}</mat-radio-button>
                <mat-radio-button value="F">{{'FORM.personForm.genderFemale' | translate}}</mat-radio-button>
                <mat-radio-button value="D">{{'FORM.personForm.genderDiverse' | translate}}</mat-radio-button>
            </mat-radio-group> 
        </div>
    </div>
         
    
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.personForm.anrede' | translate}}</mat-label>
        <input formControlName="anrede" matInput type="text">
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.personForm.titelAkademisch' | translate}}</mat-label>
        <input formControlName="titelAkademisch" matInput type="text">
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.personForm.titelAndere' | translate}}</mat-label>
        <input formControlName="titelAndere" matInput type="text">
    </mat-form-field>
    <!-- <mat-form-field>
        <mat-label>{{'FORM.personForm.reportGroup' | translate}}</mat-label>
        <input formControlName="reportGroup" matInput type="text">
    </mat-form-field> -->

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.personForm.reportGroupId' | translate}}</mat-label>
        <mat-select formControlName="reportGroupId">
            <mat-option *ngFor="let option of reportGroupOptions" [value]="option.identifier">
                {{option.title}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.personForm.address1' | translate}}</mat-label>
        <input formControlName="address1" matInput type="text">
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.personForm.address2' | translate}}</mat-label>
        <input formControlName="address2" matInput type="text">
    </mat-form-field>
    <div>
        <mat-form-field class="w-50 pr-1">
            <mat-label>{{'FORM.personForm.zip' | translate}}</mat-label>
            <input #postalCode formControlName="zip" matInput maxlength="5" type="text">
            <mat-hint align="end">{{postalCode.value.length}} / 5</mat-hint>
        </mat-form-field>
        <mat-form-field class="w-50 pl-1">
            <mat-label>{{'FORM.personForm.city' | translate}}</mat-label>
            <input formControlName="city" matInput type="text">
        </mat-form-field>
    </div>


    <mat-form-field class="w-100">
        <mat-label>{{'FORM.personForm.emailAddresse' | translate}}</mat-label>
        <input formControlName="emailAddresse" matInput type="text">
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.personForm.telefon' | translate}}</mat-label>
        <input formControlName="telefon" matInput type="text">
    </mat-form-field>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.personForm.hundeJagdlichImTreiben' | translate}}</mat-label>
        <input formControlName="hundeJagdlichImTreiben" matInput type="text">
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.personForm.hundeNachsucheGespann' | translate}}</mat-label>
        <input formControlName="hundeNachsucheGespann" matInput type="text">
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.personForm.kommentar' | translate}}</mat-label>
        <input formControlName="kommentar" matInput type="text">
    </mat-form-field>

    
</form>
<div class="sticky-bottom dialog-footer">
    <button [disabled]="!canDelete" class="second-btn delete-btn" mat-button type="button" (click)="onDelete()">
        <mat-icon>delete</mat-icon>
        {{ 'FORM.BTN_DELETE' | translate }}
    </button>

    <span class="footer-spacer"></span>

    <button class="second-btn" mat-button type="button" (click)="onCancle()">
        {{ 'cancel' | translate }}
    </button>

    <button [disabled]="!canSave" class="first-btn" mat-button (click)="submit()"><!--type="submit"-->
        {{ 'FORM.BTN_SAVE' | translate }}
    </button>
</div>
